import { SelectFields } from '@repo/toolkit/types'
import { PaginationResponse } from '@repo/ui/data-table'

import { HowDidYouObtainLECBrochureType } from '../../lib/types/fields/how-did-you-obtain-lec-brochures/how-did-you-obtain-lec-brochures'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getHowDidYouObtainLecBrochures<
  T extends FieldsSelector<HowDidYouObtainLECBrochureType>
>(fields: T) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.howDidYouObtainLECBrochure.getAll.url, null), {
        fields
      })
    )
    .get<PaginationResponse<SelectFields<HowDidYouObtainLECBrochureType, T>>>()
}
